module.exports = __webpack_public_path__ + "static/media/pt.73275ead.svg";